import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const CREATE_REQUEST = 'realhub/agencyProviderDeadlineGroup/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/agencyProviderDeadlineGroup/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/agencyProviderDeadlineGroup/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/agencyProviderDeadlineGroup/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/agencyProviderDeadlineGroup/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/agencyProviderDeadlineGroup/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createAgencyProviderDeadlineGroup(agencyProviderDeadlineGroup, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      agency_provider_deadline_group: agencyProviderDeadlineGroup,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const { agency_id } = agencyProviderDeadlineGroup
    const promise = api(`/admin/agencies/${agency_id}/deadline_groups.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.AGENCY_PROVIDER_DEADLINE_GROUP)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteAgencyProviderDeadlineGroup(agencyProvider, options){
  const config = {
    method: 'DELETE',
    body: JSON.stringify({
      agency_provider: agencyProvider,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const { agency_id, id } = agencyProvider
    const promise = api(`/admin/agencies/${agency_id}/deadline_groups/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.AGENCY_PROVIDER_DEADLINE_GROUP)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
